import api from '../utils/api';

class OrganizationService {
  // Get organization details
  async getDetails() {
    try {
      const response = await api.get('/organization/details');
      return response.data;
    } catch (error) {
      console.error('Error fetching organization details:', error);
      throw error;
    }
  }

  // Update organization details
  async updateDetails(updates) {
    try {
      const response = await api.put('/organization/details', updates);
      return response.data;
    } catch (error) {
      console.error('Error updating organization:', error);
      throw error;
    }
  }

  async updatePowerUpSettings(powerUpZoomLink) {
    try {
      const response = await api.put('/organization/power-up-settings', {
        powerUpZoomLink
      });
      return response.data;
    } catch (error) {
      console.error('Error updating Power Up settings:', error);
      throw error;
    }
  }

  // Get organization details and members
  async getMembers(params = {}) {
    try {
      const response = await api.get('/organization/members', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching organization members:', error);
      throw error;
    }
  }

  // Invite a new member
  async inviteMember(memberData) {
    try {
      const response = await api.post('/organization/members/invite', memberData);
      return response.data;
    } catch (error) {
      console.error('Error inviting member:', error);
      throw error;
    }
  }

  // Update member details
  async updateMember(userId, updates) {
    try {
      const response = await api.put(`/organization/members/${userId}`, updates);
      return response.data;
    } catch (error) {
      console.error('Error updating member:', error);
      throw error;
    }
  }

  // Remove member from organization
  async removeMember(userId) {
    try {
      const response = await api.delete(`/organization/members/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error removing member:', error);
      throw error;
    }
  }

  // Resend invitation
  async resendInvitation(userId) {
    try {
      const response = await api.post(`/organization/members/${userId}/resend-invitation`);
      return response.data;
    } catch (error) {
      console.error('Error resending invitation:', error);
      throw error;
    }
  }
}

export default new OrganizationService();
